import { Errors } from '@blink/components/src/constants/errors';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
    clearErrorsAction,
    infoErrorAction,
    organizationMembersErrorAction,
} from '@/shared/store/errors/actions';
import {
    setMeAction,
    setMeLoadingFalseAction,
    setOrganizationMembersAction,
    setOrganizationMembersLoadingFalseAction,
    setRestrictionAction,
    setUserLockedAction,
} from '@/shared/store/organization/actions';
import { GET_ME, GET_ORGANIZATION_MEMBERS } from '@/shared/store/organization/constants';
import { getMe, getOrganizationMembers, Me, Member } from '@/shared/api/organization';
import { INFO_ERROR, ORGANIZATION_MEMBERS_ERROR } from '@/shared/store/errors/constants';

function* getMeSaga(): Generator<any, any, any> {
    try {
        yield put(clearErrorsAction({ errorType: INFO_ERROR }));

        const meInfo = yield call(getMe);

        yield put(setMeAction(meInfo as Me));
    } catch (e: any) {
        if (e?.status === 403 || e?.status === 431) {
            yield put(setUserLockedAction(true));
            yield put(
                organizationMembersErrorAction({
                    message: Errors.PERMISSION_DENIED + ' to get user organisation',
                }),
            );
            yield put(setMeLoadingFalseAction());
            return;
        }

        yield put(setMeLoadingFalseAction());
        yield put(infoErrorAction({ message: Errors.INFO + ' ' + e.message }));
    }
}

function* getOrganizationMembersSaga(action: {
    type: string;
    payload: string;
}): Generator<any, any, any> {
    const id = action.payload;
    try {
        yield put(clearErrorsAction({ errorType: ORGANIZATION_MEMBERS_ERROR }));

        const organizationMembers = yield call(getOrganizationMembers, { id });

        yield put(setOrganizationMembersAction(organizationMembers as Member[]));
    } catch (e: any) {
        yield put(setOrganizationMembersLoadingFalseAction());

        if (e?.status === 403) {
            yield put(setRestrictionAction());
        }

        yield put(
            organizationMembersErrorAction({
                message:
                    e?.status === 403 || e?.status === 431
                        ? Errors.PERMISSION_DENIED + ' to get organisation members'
                        : Errors.ORGANIZATION_MEMBERS + ' ' + e.message,
            }),
        );
    }
}

export function* organizationWatcher() {
    yield takeLatest(GET_ME, getMeSaga);
    yield takeLatest(GET_ORGANIZATION_MEMBERS, getOrganizationMembersSaga);
}
